export class CampaignsMetricsBuilder {
    constructor() {
        this.metrics = {};
    }

    setConversions(conversions){
        this.metrics.conversions = conversions;
        return this;
    }

    setRevenue(revenue) {
        this.metrics.revenue = revenue;
        return this;
    }


    build(){
        return this.metrics;
    }
}
